import React from "react";
import { Plus } from "lucide-react";
import { Button } from "../ui/Button";
import type { ButtonProps } from "../ui/Button";

interface ActionButtonProps extends ButtonProps {
  label?: string;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  label = "Registrar",
  className,
  ...props
}) => {
  return (
    <Button
      variant="outline"
      className={`flex items-center gap-1 px-3 py-0.5 text-[14px] h-7 ${className || ""}`}
      {...props}
    >
      <Plus size={12} strokeWidth={2} />
      <span>{label}</span>
    </Button>
  );
};
